import { AnyAction } from 'redux'
import { ActionMeta } from 'redux-actions'
import { ITranslatePayload } from '.'
import * as actions from './actions'

const isResult = (action: AnyAction): action is ActionMeta<string, ITranslatePayload> => action.type == actions.RESULT

export const result = (payload: ITranslatePayload) => (action: AnyAction) => isResult(action) && action.meta === payload
